/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchTransactionsResponseItem } from './search-transactions-response-item';


export interface SearchTransactionsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchTransactionsResponseItem> | null;
}

